import { EducationPanel } from '@npco/zeller-design-system'
import styled from 'styled-components'

import { DEFAULT_ENTITY } from './constants'

export const ACCOUNT_ROUTE = (entityId: string) =>
  `/orgs/${entityId || DEFAULT_ENTITY}/accounts`

export const EmptyStateBanner = styled(EducationPanel)``
